/**
 * WordPress dependencies.
 */
import { Fragment } from '@wordpress/element';
import { Disabled, BaseControl, FontSizePicker, PanelBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { applyFilters, addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';
import { getFragment } from '@wordpress/url';
import { useSetting, useStyle } from '@wordpress/block-editor';

/**
 * Exteranl dependencies.
 */
import { has, last, merge, isArray } from 'lodash';

/**
 * Inner dependencies.
 */
import GutenifyFontFamilyControl from '../../../components/FontFamilyControl/index.js';
import { getParsedVar } from '../../utils';

addFilter( 'gutenify-admin-settings-design-panel', 'gutenify-admin-settings-design-panel-typography', ( content, props ) => {
	const { gStyle, siteOptions, changeSiteOptions } = props;

	let textFontFamily = has( gStyle, `styles.typography.fontFamily` ) ? getParsedVar( gStyle.styles.typography.fontFamily ) : '';
	if ( has( siteOptions, `settings.styles.typography.fontFamilySlug` ) ) {
		textFontFamily = siteOptions.settings.styles.typography.fontFamilySlug;
	}
	const textFontFamilySlug = isArray( textFontFamily ) ? last( textFontFamily ) : textFontFamily;

	let headingsFontFamily = '';
	if ( has( siteOptions, `settings.styles.elements.headings.typography.fontFamilySlug` ) ) {
		headingsFontFamily = siteOptions.settings.styles.elements.headings.typography.fontFamilySlug;
	}
	const headingsFontFamilySlug = isArray( headingsFontFamily ) ? last( headingsFontFamily ) : headingsFontFamily;

	// console.log( textFontFamily, textFontFamilySlug );
	let gutenifyStyles = {};

	if ( has( siteOptions, 'settings.styles' ) ) {
		gutenifyStyles = siteOptions.settings.styles;
	}

	const setGutenifyStyles = ( data ) => {
		changeSiteOptions( merge(
			siteOptions,
			{
				settings: {
					styles: merge( gutenifyStyles, data ),
				},
			},
		) );
	};

	const fontSizes = useSetting( 'typography.fontSizes' );
	console.log( fontSizes, useStyle );
	return (
		[ ...content, <Fragment key="gutenify-admin-settings-design-panel-typography">
			<PanelBody title={ __( 'Typography' ) } initialOpen={ 'general' === props.activePanel }>
				<div className="gutenify-field-wrapper gutenify-field-grid">
					<div className="gutenify-field-label">
						<label htmlFor="text-color-control">{ __( 'Text' ) }</label>
					</div>
					<div className="gutenify-field-control">
						<GutenifyFontFamilyControl
							label=""
							value={ textFontFamilySlug }
							onChange={ ( fontFamilySlug ) => {
								// console.log( family );
								const data = merge( gutenifyStyles, {
									typography: {
										fontFamilySlug,
									},
								} );
								setGutenifyStyles( { ...data } );
							} }
						/>
						{ fontSizes &&
						<FontSizePicker
							fontSizes={ !! fontSizes && fontSizes }
						/> }

					</div>
				</div>
				<div className="gutenify-field-wrapper gutenify-field-grid">
					<div className="gutenify-field-label">
						<label htmlFor="text-color-control">{ __( 'Heading' ) }</label>
					</div>
					<div className="gutenify-field-control">
						<GutenifyFontFamilyControl
							label=""
							value={ headingsFontFamilySlug }
							onChange={ ( fontFamilySlug ) => {
								// console.log( family );
								const data = merge( gutenifyStyles, {
									elements: {
										headings: {
											typography: {
												fontFamilySlug,
											},
										},
									},
								} );
								setGutenifyStyles( { ...data } );
							} }
						/>

					</div>
				</div>
			</PanelBody>
		</Fragment> ]
	);
} );
